(function () {

    function openModalById(id) {
        if (!id) return;

        const modal = document.getElementById(id);
        if (!modal) return;

        modal.classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('nav-open');
    }

    function closeModal(modal) {
        if (!modal) return;

        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nav-open');
    }

    // 🌍 делаем доступным глобально
    window.sgOpenModal = openModalById;
    window.sgCloseModal = function (id) {
        const modal = typeof id === 'string'
            ? document.getElementById(id)
            : id;
        closeModal(modal);
    };

    // старое поведение кликов — НЕ ЛОМАЕМ
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('[data-modal-open]');
        const closeBtn = e.target.closest('[data-modal-close]');
        const backdrop = e.target.classList && e.target.classList.contains('modal') ? e.target : null;

        if (openBtn) {
            e.preventDefault();
            openModalById(openBtn.getAttribute('data-modal-open'));
            return;
        }

        if (closeBtn || backdrop) {
            e.preventDefault();
            closeModal(closeBtn ? closeBtn.closest('.modal') : backdrop);
        }
    });

})();

